import * as React from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { useMutation } from "react-apollo";

import { Icon } from "rbx";

import { SINGLE_IMAGE_UPLOAD_MUTATION } from "../../../graphql/Uploads/Uploads.graphql";
import { getS3ImageUrl } from "../../../utils";

import "./ImageUploader.scss";

function ImageUploader({ name, value, onChange }) {
  const [uploadImage] = useMutation(SINGLE_IMAGE_UPLOAD_MUTATION);
  const handleChange = async e => {
    e.preventDefault();
    const {
      target: {
        files: [file]
      }
    } = e;
    if (file) {
      const { data } = await uploadImage({ variables: { file } });
      onChange({
        target: {
          name,
          value: data.uploadImage.filepath
        }
      });
    }
  };

  const imageUrl = React.useMemo(() => getS3ImageUrl(value), [value]);

  return (
    <div className="image-uploader">
      <div className="image-uploader-edit">
        <label htmlFor="image-uploader">
          <input
            accept="image/*"
            id="image-uploader"
            name={name}
            type="file"
            onChange={handleChange}
          />
          <Icon>
            <FontAwesomeIcon icon="pencil-alt" />
          </Icon>
        </label>
      </div>
      <div className="image-uploader-preview">
        <div
          id="image-preview"
          style={{ backgroundImage: `url(${imageUrl})` }}
        />
      </div>
    </div>
  );
}
ImageUploader.propTypes = {
  name: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func
};
ImageUploader.defaultProps = {
  value: ""
};

export default ImageUploader;
